const BLACK_FRIDAY = {
  CATEGORY_NAME: 'Black Friday',
  LANDING_TYPE: 'BLACK_FRIDAY',
  GLOSSARY: {
    PAGE_TYPES: {
      CATEGORY: 'CATEGORY',
      BLACK_FRIDAY: 'BLACK_FRIDAY',
      SUBCATEGORY: 'SUBCATEGORY',
      STORE: 'STORE',
    },
    PAGES: {
      A: [
        {
          name: 'Air Fryer',
          slug: 'air-fryer',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Amazon',
          slug: 'amazon',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Americanas',
          slug: 'americanas',
          type: 'STORE',
        },
        {
          name: 'Ar Condicionado',
          slug: 'ar-condicionado',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Aspirador de Pó',
          slug: 'aspirador-de-po',
          type: 'SUBCATEGORY',
        },
      ],
      B: [
        {
          name: 'Bicicleta',
          slug: 'bicicleta',
          type: 'BLACK_FRIDAY',
        },
      ],
      C: [
        {
          name: 'Cadeira de Escritório',
          slug: 'cadeira-de-escritorio',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Cadeira Gamer',
          slug: 'cadeira-gamer',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Cafeteira',
          slug: 'cafeteiras',
          type: 'SUBCATEGORY',
        },
        {
          name: 'Caixa de Som',
          slug: 'caixa-de-som',
          type: 'SUBCATEGORY',
        },
        {
          name: 'Cama',
          slug: 'cama',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Casas Bahia',
          slug: 'casas-bahia',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Celular',
          slug: 'celular',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Centauro',
          slug: 'centauro',
          type: 'STORE',
        },
        {
          name: 'Cervejeira',
          slug: 'cervejeira',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Colchão',
          slug: 'colchao',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Cooktop',
          slug: 'cooktop',
          type: 'SUBCATEGORY',
        },
      ],
      D: [
        {
          name: 'Dell',
          slug: 'dell',
          type: 'BLACK_FRIDAY',
        },
      ],
      E: [
        {
          name: 'Eletrodomésticos',
          slug: 'eletrodomesticos',
          type: 'CATEGORY',
        },
        {
          name: 'Extra',
          slug: 'extra',
          type: 'BLACK_FRIDAY',
        },
      ],
      F: [
        {
          name: 'Fogão',
          slug: 'fogao',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Fone de Ouvido',
          slug: 'fone-de-ouvido',
          type: 'SUBCATEGORY',
        },
        {
          name: 'Forno Elétrico',
          slug: 'forno-eletrico',
          type: 'SUBCATEGORY',
        },
        {
          name: 'Fralda',
          slug: 'fralda',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Fritadeira',
          slug: 'fritadeira-eletrica',
          type: 'SUBCATEGORY',
        },
      ],
      G: [
        {
          name: 'Galaxy',
          slug: 'galaxy',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Games',
          slug: 'game',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Geladeira',
          slug: 'geladeira',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Guarda Roupa',
          slug: 'guarda-roupa',
          type: 'BLACK_FRIDAY',
        },
      ],
      H: [
        {
          name: 'Headset',
          slug: 'headset',
          type: 'BLACK_FRIDAY',
        },
      ],
      I: [
        {
          name: 'Impressora',
          slug: 'impressora',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'iPhone',
          slug: 'iphone',
          type: 'BLACK_FRIDAY',
        },
      ],
      J: [
        {
          name: 'JBL',
          slug: 'jbl',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Jogo de Panelas',
          slug: 'jogo-de-panelas',
          type: 'BLACK_FRIDAY',
        },
      ],
      K: [
        {
          name: 'Kabum',
          slug: 'kabum',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Kindle',
          slug: 'kindle',
          type: 'BLACK_FRIDAY',
        },
      ],
      L: [
        {
          name: 'Lava Louças',
          slug: 'lava-loucas',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Liquidificador',
          slug: 'liquidificador',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Livro',
          slug: 'livro',
          type: 'BLACK_FRIDAY',
        },
      ],
      M: [
        {
          name: 'Magazine Luiza',
          slug: 'magazine-luiza',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Maquiagem',
          slug: 'maquiagem',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Máquina de Lavar',
          slug: 'maquina-de-lavar',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Marabraz',
          slug: 'marabraz',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Micro-ondas',
          slug: 'micro-ondas',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Monitor',
          slug: 'monitor',
          type: 'SUBCATEGORY',
        },
        {
          name: 'Motorola',
          slug: 'motorola',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Móveis',
          slug: 'moveis',
          type: 'BLACK_FRIDAY',
        },
      ],
      N: [
        {
          name: 'Nespresso',
          slug: 'nespresso',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Netshoes',
          slug: 'netshoes',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Nintendo Switch',
          slug: 'nintendo-switch',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Notebook',
          slug: 'notebook',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Notebook Gamer',
          slug: 'notebook-gamer',
          type: 'BLACK_FRIDAY',
        },
      ],
      P: [
        {
          name: 'PC Gamer',
          slug: 'pc-gamer',
          type: 'SUBCATEGORY',
        },
        {
          name: 'Perfume',
          slug: 'perfume',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Pichau',
          slug: 'pichau',
          type: 'STORE',
        },
        {
          name: 'Placa de Vídeo',
          slug: 'placa-de-video',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Pneu',
          slug: 'pneu',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Pontofrio',
          slug: 'pontofrio',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Processador',
          slug: 'processador',
          type: 'SUBCATEGORY',
        },
        {
          name: 'PS4',
          slug: 'ps4',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'PS5',
          slug: 'ps5',
          type: 'BLACK_FRIDAY',
        },
      ],
      R: [
        {
          name: 'Roupas',
          slug: 'roupas',
          type: 'BLACK_FRIDAY',
        },
      ],
      S: [
        {
          name: 'Samsung',
          slug: 'samsung',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Shoptime',
          slug: 'shoptime',
          type: 'STORE',
        },
        {
          name: 'Smart TV',
          slug: 'tv',
          type: 'SUBCATEGORY',
        },
        {
          name: 'Smartphone',
          slug: 'smartphones-tablets-e-telefones',
          type: 'CATEGORY',
        },
        {
          name: 'Smartwatch',
          slug: 'smartwatch',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Soundbar',
          slug: 'soundbar',
          type: 'SUBCATEGORY',
        },
        {
          name: 'SSD',
          slug: 'hd-ssd',
          type: 'SUBCATEGORY',
        },
        {
          name: 'Submarino',
          slug: 'submarino',
          type: 'BLACK_FRIDAY',
        },
      ],
      T: [
        {
          name: 'Tablet',
          slug: 'tablet',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Teclado e Mouse',
          slug: 'teclado-mouse',
          type: 'SUBCATEGORY',
        },
        {
          name: 'Tênis',
          slug: 'tenis',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'TV',
          slug: 'tv',
          type: 'BLACK_FRIDAY',
        },
      ],
      V: [
        {
          name: 'Ventilador',
          slug: 'ventilador',
          type: 'BLACK_FRIDAY',
        },
      ],
      X: [
        {
          name: 'Xbox',
          slug: 'xbox',
          type: 'BLACK_FRIDAY',
        },
        {
          name: 'Xiaomi',
          slug: 'xiaomi',
          type: 'BLACK_FRIDAY',
        },
      ],
      Z: [
        {
          name: 'Zenfone',
          slug: 'zenfone',
          type: 'BLACK_FRIDAY',
        },
      ],
    },
  },
};

export default Object.freeze(BLACK_FRIDAY);
